import React from 'react'
import { Stack, Typography, Container, Button, Chip, Grid, Box, Card } from "@mui/material";
import Navbar from '../../components/Navbar';
import ShowRouting from '../../components/ShowRouting';
import UserImage from '../../assets/Images/Person1.png'
import StarIcon from "@mui/icons-material/Star";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CreateIcon from '@mui/icons-material/Create';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import Footer from '../../components/Footer'
import { Link } from 'react-router-dom'



const BookingDetails = () => {
    const isVerified = true;
    const rating = 4.5
    const personRating = rating;
    return (
        <>
            <Navbar />

            <Container>
                <ShowRouting route={'Home / Profile / My Bookings / Booking Details'} />
                <Typography variant="h6" gutterBottom component="div">
                    Booking Details
                </Typography>
                <Stack direction="row" justifyContent='space-between'>
                    <Stack direction='row'>
                        <Stack>
                            <img src={UserImage} alt="Banner Person" />
                        </Stack>
                        <Stack direction='column' className='ml-10'>
                            <Typography variant="h6" gutterBottom component="div">
                                John Doe
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                AC Expert, Appliances, Electrician
                            </Typography>
                            <Stack>
                                <Stack direction='row'>

                                    <Chip
                                        label={rating}
                                        size="small"
                                        style={{ background: "#FFF0E8" }}
                                        icon={
                                            <StarIcon
                                                style={
                                                    personRating > 4.5
                                                        ? { color: "green" }
                                                        : { color: "#FF6D1C" }
                                                }
                                            />
                                        }
                                    ></Chip>

                                    {isVerified == true ? (
                                        <div className="d-flex ml-3">
                                            <CheckCircleRoundedIcon style={{ color: "#00D48D" }} />
                                            <Typography variant="button" display="block" gutterBottom>
                                                Certfied
                                            </Typography>
                                        </div>
                                    ) : null}
                                </Stack>
                            </Stack>

                            <Stack>
                                <div>
                                    <Button
                                        variant="outlined"
                                    >
                                        View Conversation
                                    </Button>
                                </div>
                            </Stack>

                        </Stack>

                    </Stack>
                    <Stack direction='column' spacing={2}>
                        <Stack>
                            <div>
                                <Link to='/complete-rating'>
                                    <Button
                                        variant="contained"
                                    >
                                        Complete Order
                                    </Button>
                                </Link>
                            </div>
                        </Stack>
                        <Stack>
                            <div>
                                <Button
                                    variant="outlined"
                                    color="error"
                                >
                                    I have a problem
                                </Button>
                            </div>
                        </Stack>
                    </Stack>
                </Stack>
                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card

                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Title
                            </Typography>
                            <Typography variant="body2" gutterBottom className='ml-7'>
                                I need home cleaning services for my new appartment.
                            </Typography>
                        </Card>
                    </Grid>

                </Grid>
                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card

                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Details
                            </Typography>
                            <Typography variant="body2" gutterBottom className='ml-7'>
                                I need home cleaning services for my new appartment. I need home cleaning services for my new appartment. I need home cleaning services for my new appartment. I need home cleaning services for my new appartment. I need home cleaning services for my new appartment.
                            </Typography>
                        </Card>
                    </Grid>

                </Grid>
                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Images and Videos
                            </Typography>

                        </Card>
                    </Grid>

                </Grid>




                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Booking Details

                                <Button className='ml-16 mb-2' startIcon={<CreateIcon />}>Edit</Button>
                            </Typography>
                            <Stack direction='row'
                                spacing={{ xs: 4, sm: 4, md: 16 }} >
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Address


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >
                                        <span>
                                            <LocationOnOutlinedIcon />
                                        </span>
                                        House 262, Street 11, Petersbrough, UK


                                    </Typography>
                                </Stack>
                            </Stack>
                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 19 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Date


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >
                                        <span>
                                            <CakeOutlinedIcon />
                                        </span>
                                        Monday, 12th January


                                    </Typography>
                                </Stack>
                            </Stack>

                        </Card>
                    </Grid>

                </Grid>






                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Pricing
                            </Typography>
                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 19 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Item Price


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >

                                        20$


                                    </Typography>
                                </Stack>
                            </Stack>

                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 17 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Extra Service


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >

                                        0$


                                    </Typography>
                                </Stack>
                            </Stack>
                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 23 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Total


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >

                                        20$


                                    </Typography>
                                </Stack>
                            </Stack>
                        </Card>
                    </Grid>

                </Grid>
                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Payment Method
                            </Typography>
                            <Stack style={{ padding: '30px' }}>
                                <Box

                                    sx={{
                                        width: 300,
                                        height: 150,

                                        backgroundColor: 'primary.dark',

                                    }}
                                >
                                    <Stack>
                                        <Stack>
                                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px', }} color='white'>
                                                Visa
                                            </Typography>
                                        </Stack>

                                        <Stack className='ml-7'>
                                            <Typography variant="body2" gutterBottom color='white'>
                                                Jhon Doe
                                            </Typography>
                                        </Stack>

                                        <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 13 }} className='mt-4'>
                                            <Stack className='ml-7'>
                                                <Typography variant="body2" gutterBottom color='white'>
                                                    ••••••••••••3456
                                                </Typography>
                                            </Stack>
                                            <Stack >
                                                <Typography variant="body2" gutterBottom color='white'>
                                                    10/23
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>

                </Grid>
            </Container>
            <Footer />

        </>
    )
}

export default BookingDetails